import React from 'react'
import {
  Background,
  Modal,
  ModalClose,
  ModalContent,
  TileOverlay,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { ModalEmailCapture } from 'components/EmailCapture'
import Image from 'components/LegacyImage'
import { SimpleMCLogo } from 'components/Navigation/MCLogo/SimpleMCLogo'
import { GetNotifiedConfirmationToast } from './GetNotifiedConfirmationToast'
import { useGetNotifiedModal } from './GetNotifiedModalContext'
import classes from './GetNotifiedModal.module.scss'

const CloseButton = () => (
  <>
    <ModalClose className='mc-m-4 d-none d-md-block' />
    <ModalClose className='d-md-none mc-m-4 mc-corners--circle mc-theme-light mc-bg-container-medium' />
  </>
)

const CoverImage = () => {
  const { mobileImage, desktopImage } = useGetNotifiedModal()

  return (
    <>
      <Image
        className='d-md-none mc-corners-top-left--6 mc-corners-top-right--6'
        src={mobileImage || desktopImage || ''}
        layout='fill'
        objectFit='cover'
        objectPosition='top'
        alt=''
      />
      <Image
        className='d-none d-md-block mc-corners-top-left--6 mc-corners-bottom-left--6'
        src={desktopImage || mobileImage || ''}
        layout='fill'
        objectFit='cover'
        objectPosition='top'
        alt=''
      />
    </>
  )
}

const EmailCaptureContent = () => {
  const { t } = useTranslation('@mc/next')
  const { slug, onEmailCaptured } = useGetNotifiedModal()

  return (
    <div className='mc-px-4 mc-pt-md-9 mc-pb-9 mc-h-100'>
      <div className='container d-flex flex-column align-items-center align-items-md-start justify-content-center mc-h-100'>
        <h2 className='mc-text-h2 d-none d-md-block'>
          {t('episode.comingSoon.modal.title')}
        </h2>
        <h1 className='mc-text-h1 d-md-none'>
          {t('episode.comingSoon.modal.title')}
        </h1>
        <p className='mc-text-color--tint mc-my-5'>
          {t('episode.comingSoon.modal.description')}
        </p>
        <ModalEmailCapture
          trackProps={{
            location: 'episode_page_popup_new_episode',
            campaign: 'new_releases',
            contentType: 'series',
            slug: slug || '',
          }}
          onEmailCaptured={onEmailCaptured}
        />
      </div>
    </div>
  )
}

export const GetNotifiedModal = () => {
  const { closeModal, showModal } = useGetNotifiedModal()

  return (
    <>
      <Modal
        className='mc-corners--6'
        size='large'
        show={showModal}
        onClose={() => closeModal()}
      >
        <ModalContent className={`mc-corners--6 ${classes.modalContainer}`}>
          <Background
            color='dark'
            className='mc-corners--6 mc-h-100'
            fit='content'
          >
            <div className='container mc-p-0 mc-corners--6'>
              <div className='position-fixed mc-m-8' style={{ zIndex: 1000 }}>
                <SimpleMCLogo />
              </div>
              <CloseButton />
              <div className='row no-gutters mc-text--center mc-text-md--left'>
                <div className='col-12 col-md-4'>
                  <div className={`mc-w-100 ${classes.imageContainer}`}>
                    <CoverImage />
                    <TileOverlay
                      className={`d-md-none mc-corners-top-left--6 mc-corners-top-right--6 ${classes.customGradientBottom}`}
                    />
                  </div>
                </div>

                <div className='d-none d-md-block col-8 mc-bg-container-tint-dark'>
                  <EmailCaptureContent />
                </div>

                <div className='d-md-none col-12'>
                  <EmailCaptureContent />
                </div>
              </div>
            </div>
          </Background>
        </ModalContent>
      </Modal>
      <GetNotifiedConfirmationToast />
    </>
  )
}
